import ArticleLayout from "@/components/feature/ArticleLayout";

export default function QualityArticle() {
  return <ArticleLayout slug="pandabuy-sheet-quality-tips" />;
}